module.exports = require("./ca-ES.js");